import React from 'react';
import styled from 'styled-components';
import { useStaticQuery, graphql } from 'gatsby';

import Container from 'gatsby-theme-core/src/components/container';
import Button from 'gatsby-theme-core/src/components/button/index';
import CoreImage from 'gatsby-theme-core/src/components/image';

const ShopItem = () => {
  const { product } = useStaticQuery(graphql`
    query PDVShopItem {
      product: wpSimpleProduct(databaseId: { eq: 73884 }) {
        id
        name
        ... on WpSimpleProduct {
          uri
          price
          salePrice
          regularPrice
        }
        image {
          gatsbyImage(
            layout: CONSTRAINED
            placeholder: BLURRED
            width: 600
            height: 600
            cropFocus: CENTER
          )
        }
      }
    }
  `);

  return (
    <div>
      <Container small>
        <Inner>
          <div>
            <Image
              image={product.image}
              fallbackAlt={product.name}
            />
          </div>
          <article>
            <Title>{product.name}</Title>

            <Prices>
              {product.salePrice && (
                <>
                  <SalePrice>{product.regularPrice}</SalePrice>
                  <Price>{product.salePrice}</Price>
                </>
              )}
              {!product?.salePrice && (
                <Price>{product.regularPrice}</Price>
              )}
            </Prices>

            <StyledButton href={`https://shop.dcdw.nl${product.uri}`}>Bestel hem nu</StyledButton>
            &nbsp;
            &nbsp;
            <StyledButton outline to="/shop">Bekijk onze shop</StyledButton>
          </article>
        </Inner>
      </Container>
    </div>
  );
};

const Image = styled(CoreImage)`
  display: block !important;
  margin: 0 auto;
  width: 75%;

  @media all and (min-width: ${(props) => props.theme.breakingpoints.md}) {
    width: auto;
  }
`;

const StyledButton = styled(Button)`
  display: block;
  min-width: 188px;
  text-align: center;
  @media all and (min-width: ${(props) => props.theme.breakingpoints.md}) {
    display: inline-block;
  }
`;

const Price = styled.span`
  font-family: ${(props) => props.theme.standoutFontFamily};
  display: block;
  color: ${(props) => props.theme.grayColor};
  font-size: 1.556rem;
  font-weight: 700;
`;

const SalePrice = styled.span`
  text-decoration: line-through;
  margin-right: .5rem;
`;

const Prices = styled.div`
  display: flex;
  align-items: center;
  padding: 15px 0;
`;

const Title = styled.h2`
  margin: 0;
  font-family: ${(props) => props.theme.standoutFontFamily};
  font-size: 1.556rem;
  text-transform: uppercase;
`;

const Inner = styled.div`
  @media all and (min-width: ${(props) => props.theme.breakingpoints.md}) {
    display: grid;
    grid-auto-rows: auto;
    grid-template-columns: 1fr 2fr;
    grid-gap: 4rem;
    align-items: center;
  }
`;

export default styled(ShopItem)``;
